export const checkValidField = (fieldValue: any | undefined | null) => {
  if (!fieldValue || fieldValue === 'n/a') {
    return false;
  } else {
    return true;
  }
};
